import { Back } from '../../components/buttons/backButton/Back'
import { Pdf } from '../../components/pdf/Pdf'
import { translations } from '../../configs/translations'
import { useStore } from '../../store/store'
import './TermsViewer.css'

export const TermsViewer = () => {
	const language = useStore(state => state.language)
	const t = translations[language]

	return (
		<div className='docViewer-wrapper'>
			<div className='window docViewer'>
				<Back onClick={() => window.history.back()} />
				<br />
				<Pdf name={'terms_of_use'} toolbar={0} navpanes={0} scrollbar={0} />
			</div>
		</div>
	)
}
